T.BS.Radio = Class(
	/**
	 * @lends {T.BS.Radio#}
	 */
	{
		__construct(par) {
			this.par = par || {};
			this._n = ++T.BS.Radio._n;

			this.node = mkE({
				tag: 'div',
				className: (this.par.noGroup !== true ? 'form-group ' : '') + 'custom-control custom-radio' + (this.par.inline ? ' custom-control-inline' : '')
			});

			let attr = {};
			if (this.par.required) {
				attr.required = true;
			}

			this._input = mkE({
				tag: 'input',
				type: 'radio',
				className: 'custom-control-input',
				name: this.par.name,
				id: 'form-radio-' + this._n,
				attr: attr,
				checked: this.par.checked || false,
				onchange: this._onChange,
				value: this.par.value
			}).append(this.node);

			if (this.par.value) {
				this._input.value = this.par.value;
			}

			if (this.par.label) {
				this._label = mkE({
					tag: 'label',
					className: 'custom-control-label',
					attr: {
						for: 'form-radio-' + this._n
					},
					text: this.par.label
				}).append(this.node);
			}

			if (this.par.help) {
				mkE({
					tag: 'small',
					className: 'form-text text-muted',
					text: this.par.help
				}).append(this.node);
			}

			this._errorNode = mkE({
				tag: 'div',
				className: 'invalid-feedback'
			}).append(this.node);

			if (this.par.disabled) {
				this.disabled(this.par.disabled);
			}
		},

		value(v) {
			if (typeof v === "undefined") {
				return this._input.value;
			}
			this._input.value = v;
			return this._input.value;
		},

		checked(v) {
			if (typeof v === "undefined") {
				return this._input.checked;
			}
			this._input.checked = v;
			return this._input.checked;
		},

		disabled(v) {
			if (typeof v === "undefined") {
				return this._input.disabled;
			}
			this._input.disabled = v;
			return this._input.disabled;
		},

		_onChange(e) {
			if (this.par.onChange) {
				return this.par.onChange(e);
			}
		},

		error(error) {
			clearNode(this._errorNode);
			if (!error) {
				removeClassName(this._input, 'is-invalid');
				return;
			}
			addClassName(this._input, 'is-invalid');
			if (error !== true) {
				mkE.appendTypeElement(this._errorNode, error);
			}
		}
	},
	mkE.Base
);
T.BS.Radio._n = 0;